// extracted by mini-css-extract-plugin
export default {"activation-box":"index_activation-box__+km+e"};